import { useState ,useRef} from "react";
import { FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";

import { FilterBtn, BtnSecondary, BtnPrimary } from "./buttons";
import { DesktopDatePicker,LocalizationProvider} from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { parseISO } from "date-fns";
import { useEffect } from "react";

const date = new Date();
const PayOutSearchBar = (props)=>{

    // const [fieldName,setFieldName] = useState('all');
    // const [field,setField] = useState('');
    const [isNumber,setIsNumber] = useState(false);
    const formFilledRef = useRef(props.field ===""? true : false);


    const changeHandler = ({target:{name,value}})=>{
        switch (name) {
            case 'fieldName':
                props.setFieldName(value)
                if(value==="mobileNumber"){
                    setIsNumber(true);
                } else{
                    setIsNumber(false);
                }
                break;

           

            case 'coursename':
               
            
                // if(isNumber){
                //     if(isNaN(value))return;
                // }
                props.setCourseName(value.trimLeft())
                // props.setErrorField("")
                
                break;
            case 'userSearch':
               
            if (!isNaN(value) && /^\d+$/.test(value)) { // Check if value is a number
                if (value.length > 10) {
                    value = value.slice(0, 10); // Limit to 10 digits
                }
            }
                props.setUserSearch(value.trimLeft())
                // props.setErrorField("")
                
                break;
        
            default:
                break;
            
        }
        
    }

   
    const handleDateChange=(value,event,name)=>{
        switch (name) {
            case "startDateFilter":
          
            props.setStartDateFilter(value);
                break;
            case "endDateFilter":
                props.setEndDateFilter(value);
                break;
        
            default:
                break;
        }
    }
    return(
        
        <div className="search-by">
                <p style={{marginLeft:"9px"}}>Search by :</p>
                <form className="search-form">
                    <div>
                    {/* <FormControl sx={{minWidth:100}} size="small">
                        <InputLabel>Field name</InputLabel>
                    <Select
                    
                    label="field name"
                    name="fieldName"
                    onChange={changeHandler}
                    value={props.fieldName}
                    >
                        <MenuItem value={'all'}>All</MenuItem>
                        {props.selectItems.map((item)=>{
                            if(item.isSearch===false){
                                return                                    
                            }

                            return(
                                <MenuItem key={item.valueKey?item.valueKey:item.value} value={item.valueKey?item.valueKey:item.value}>{item.name}</MenuItem>
                            )
                        })}
                    </Select>
                    </FormControl> */}
              
                    
                    <>
                    <FormControl >
                        <TextField
                        sx={{fontSize:"10px"}}
                        //    autoComplete="off"
                        size="small"
                         variant="outlined" name="coursename" onChange={changeHandler}  value={props.courseName} label="Enter Course Name"/>
                    </FormControl>
                    <FormControl >
                        <TextField
                        sx={{fontSize:"10px"}}
                        //    autoComplete="off"
                        size="small"
                         variant="outlined" name="userSearch" onChange={changeHandler}  value={props.userSearch} label="Enter Email/MobileNo"/>
                    </FormControl></>
                    
                    
                    </div>
                    {props.dateFilter&&<LocalizationProvider dateAdapter={AdapterDateFns}>
                        <FormControl className="FormControl">
                        
                                <DesktopDatePicker
                                label= "From"
                                inputFormat="dd/MM/yyyy"
                                autoComplete="off"
                                value={props.startDateFilter}
                                onChange={(event,value)=>handleDateChange(event,value,'startDateFilter')}
                                renderInput={(params) => <TextField size="small"  {...params}  />}
                                
                                />
 
                                               
                            
                        </FormControl>
                        <FormControl className="FormControl">
                        <DesktopDatePicker
                                label= "To"
                                inputFormat="dd/MM/yyyy"
                                size={20}
                                autoComplete="off"
                                minDate={props.startDateFilter}
                                value={props.endDateFilter}
                                onChange={(event,value)=>handleDateChange(event,value,'endDateFilter')}
                                renderInput={(params) => <TextField size="small" {...params} />}

                                />
                        </FormControl>
                    </LocalizationProvider>}
                    <div className="search-form-btns" style={{paddingBottom:"20px"}}>
                        
                    <BtnSecondary action={props.submitForm} >
                        SUBMIT
                    </BtnSecondary>
                    <BtnPrimary action={(e)=>props.reset()}>
                        RESET
                    </BtnPrimary>
                    </div>
                </form> 
            </div> 
        
    )
}

export default PayOutSearchBar